import React, { Component } from "react";
import PropTypes from "prop-types";
import LinkButton from "../../UI/atoms/buttons/LinkButton/LinkButton";
import ZommedImage from "../../UI/atoms/images/ZommedImage";

class ProductListPromoBlock extends Component {
  render() {
    return (
      <div className="mb-lg-50">
        <div className="collection-head__promoboxes row">
          <div className="col-12 col-md-12 mt-0 mb-30">
            <div className="promobox promobox--type-04 position-relative d-flex flex-column align-items-center text-center">
              <div className="image-animation-trigger w-100">
                <ZommedImage
                  className="promobox__image"
                  src="https://cdn.shopify.com/s/files/1/0026/2910/7764/files/07_47125420-7886-4ee6-a833-4ac7e6fe0b91_900x@2x.progressive.png.jpg?v=1538403024"
                  srcSet="https://cdn.shopify.com/s/files/1/0026/2910/7764/files/07_47125420-7886-4ee6-a833-4ac7e6fe0b91_900x.progressive.png.jpg?v=1538403024 1x, https://cdn.shopify.com/s/files/1/0026/2910/7764/files/07_47125420-7886-4ee6-a833-4ac7e6fe0b91_900x@2x.progressive.png.jpg?v=1538403024 2x"
                />
                <div className="promobox__content absolute-stretch d-flex flex-column flex-center px-15 py-7 overflow-hidden pointer-events-none">
                  <p className="promobox__text-line-01 h5 mb-5">
                    SALE & SPECIAL OFFERS
                  </p>
                  <p className="promobox__text-line-02 h2 mt-5 mb-0">20% OFF</p>
                  <p className="promobox__text-line-03 h6 mt-10 mb-0">
                    Free shipping all orders of $49
                  </p>
                  <LinkButton
                    className="promobox__btn px-20 mt-25 pointer-events-all"
                    variant="secondary"
                    text="Discover More"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductListPromoBlock.propTypes = {};

export default ProductListPromoBlock;
